export enum CustomClaimMessages {
  defaultClaims = "customClaim.defaultClaims",
  additionalUserClaim = "customClaim.additionalUserClaim",
  restrictedUserClaim = "customClaim.restrictedUserClaim",
}

export interface TranslationCustomClaimMessages {
  [CustomClaimMessages.defaultClaims]: string;
  [CustomClaimMessages.additionalUserClaim]: string;
  [CustomClaimMessages.restrictedUserClaim]: string;
}